export default {
	TABLE_TITLE: 'Markets',
	MARKETS_ADDED: 'Markets added',
	MARKETS_EDITED: 'Markets edited',
	MARKETS_DELETED: 'Markets deleted',
	DETAILS_TOOLTIP: 'Details',
	TIPS_EXPORT_TOOLTIP: 'Tips export',
};
